import React from 'react';
import { Tag } from '@bettercomp/ui-components';

import cn from './styles.module.scss';

type SurveySeasonBadgeProps = {
  label: string;
};

export function SurveySeasonBadge({ label }: SurveySeasonBadgeProps) {
  return (
    <Tag tag={{ id: 0, name: label }} className={cn.workflowTag} data-testid="surveySeasonBadge" />
  );
}
